import { ImageUp, Trash2, FileText } from "lucide-react";
import { useEffect, useState } from "react";

interface ImageUploadProps {
  label: string;
  currentImage?: string;
  onImageChange: (file: File | null) => void;
  required?: boolean;
  disabled:boolean;
}

const ImageUpload: React.FC<ImageUploadProps> = ({
  label,
  currentImage,
  onImageChange,
  required = false,
  disabled
}) => {
  const [preview, setPreview] = useState<string | null>(currentImage || null);

  useEffect(() => {
    if (currentImage) {
      setPreview(currentImage);
    }
  }, [currentImage]);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      onImageChange(file);
      const reader = new FileReader();
      reader.onload = (e) => setPreview(e.target?.result as string);
      reader.readAsDataURL(file);
    }
  };

  const handleDelete = () => {
    setPreview(null);
    onImageChange(null);
    // Clear the file input value
    const input = document.getElementById(
      `upload-${label.replace(/\s+/g, "-").toLowerCase()}`
    ) as HTMLInputElement;
    if (input) {
      input.value = "";
    }
  };

  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <div className="relative">
        <input
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          className="hidden"
          id={`upload-${label.replace(/\s+/g, "-").toLowerCase()}`}
          disabled={disabled}
        />
        <ImageUp className="w-5 h-5 text-white" />
        <label
          htmlFor={`upload-${label.replace(/\s+/g, "-").toLowerCase()}`}
          className="flex flex-col items-center justify-center w-full h-32 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer hover:bg-gray-50 relative overflow-hidden"
        >
          {preview ? (
            <>
              <img
                src={preview}
                alt={label}
                className="h-full "
              />
              <button
                type="button"
                disabled={disabled}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleDelete();
                }}
                className="absolute top-2 right-2 p-1 bg-red-500 text-white rounded-full hover:bg-red-600 transition-colors"
                title="Delete image"
              >
                <Trash2 className="w-4 h-4" />
              </button>
            </>
          ) : (
            <div className="flex flex-col items-center justify-center pt-5 pb-6">
              <FileText className="w-8 h-8 text-gray-400 mb-2" />
              <p className="text-sm text-gray-500">Click to upload {label}</p>
            </div>
          )}
        </label>
      </div>
    </div>
  );
};

export const ImageGrid: React.FC<{
  images: Array<{
    label: string;
    src?: string;
    onChange: (file: File | null) => void;
    required?: boolean;

  }>
  ;
  disabled:boolean;
}> = ({ images,disabled }) => (
  <div className="grid grid-cols-2 gap-4">
    {images.map((image, index) => (
      <ImageUpload
        key={index}
        label={image.label}
        currentImage={image.src}
        onImageChange={image.onChange}
        required={image.required}
        disabled={disabled}
      />
    ))}
  </div>
);